import {ApiStatus} from '../../models';
import {SubscriptionActionTypes, SubscriptionActions} from '../actions/subscriptionActions';

export const initialSubscriptionState: ISubscriptionState = {
  loadingStatus: ApiStatus.LOADED,
  products: [],
}

export interface ISubscriptionState {
  loadingStatus: ApiStatus;
  products: any;
}

export default function subscriptionReducer(
  state: ISubscriptionState = initialSubscriptionState,
  action: SubscriptionActions
): ISubscriptionState {
  switch (action.type) {
    case SubscriptionActionTypes.LOAD_PRODUCTS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADING
      };
    case SubscriptionActionTypes.LOADED_PRODUCTS:
      return {
        ...state,
        loadingStatus: ApiStatus.LOADED,
        products: action.payload
      }
    case SubscriptionActionTypes.LOADING_PRODUCTS_FAILED:
      return {
        ...state,
        loadingStatus: ApiStatus.FAILED
      }

    default:
      return state;
  }
}
